import api from './api';

const API_URL = process.env.REACT_APP_API_URL || '';

const esignatureApi = {
  getAll: (params) => api.get('/esignature', { params }),

  getById: (id) => api.get(`/esignature/${id}`),

  create: (formData) => api.post('/esignature', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  delete: (id) => api.delete(`/esignature/${id}`),

  renvoyer: (id, data) => api.post(`/esignature/${id}/renvoyer`, data),

  // Routes publiques (sans auth) — utilisées par SignaturePublic
  getPublicInfo: (token) =>
    fetch(`${API_URL}/api/signature-public/${token}`).then(r => {
      if (!r.ok) return r.json().then(d => Promise.reject(d));
      return r.json();
    }),

  submitSignature: (token, signatureBlob) => {
    const formData = new FormData();
    formData.append('signature', signatureBlob, 'signature.png');
    return fetch(`${API_URL}/api/signature-public/${token}/signer`, {
      method: 'POST',
      body: formData,
    }).then(r => {
      if (!r.ok) return r.json().then(d => Promise.reject(d));
      return r.json();
    });
  },

  refuserSignature: (token) =>
    fetch(`${API_URL}/api/signature-public/${token}/refuser`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }).then(r => {
      if (!r.ok) return r.json().then(d => Promise.reject(d));
      return r.json();
    }),
};

export default esignatureApi;
